import React from 'react';
import { Fragment } from 'react';
import { Grid, Image, Segment } from 'semantic-ui-react';
import PageMetaData from '../../app/common/elements/PageMetaData';

export default function Disclosure() {
  return (
    <Fragment>
      <PageMetaData title='Affiliate Disclosure' />
      <Grid>
        <Grid.Column
          width={16}
          style={{ textAlign: 'center' }}
          className='pageHeader'
        >
          <h1 className='pageTitle' style={{ verticalAlign: 'middle' }}>
            Affiliate Disclosure
          </h1>
        </Grid.Column>
      </Grid>
      <Grid className='pageBody'>
        <Grid.Column
          width={3}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Image src='/assets/images/coffee_300.png' />
        </Grid.Column>
        <Grid.Column computer={10} mobile={13}>
          <Segment>
            <h3>Affiliate Disclosure</h3>
            <p>
              This website contains Google AdSense ads and affiliate links. The
              affiliate links are in the form of banner ads and text links.
            </p>

            <p>
              When you click an affiliate link, we receive a small commission
              from the vendor. This is tracked using a code in the affiliate
              links or a custom coupon code. It is important to note that this
              is at no additional cost to you at all. The small amount we get
              from these helps to fund the running and upkeep of this site.
            </p>

            <p>
              For the largest part, the majority of links on this site are not
              paid affiliate links and are simply submitted by our admins or
              members, after all the primary focus is to bring you amazing
              resources that are both useful and honestly rated. However, in the
              interest of full disclosure, please assume that all links to
              services, tools, courses, and other commercial sites are paid
              links, similar to if you went to a price comparison site.
            </p>

            <p>
              This website and its owner do not control the content of the
              advertisements or the conduct of the third parties once you leave
              this site.
            </p>
          </Segment>
        </Grid.Column>
        <Grid.Column width={16}>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </Grid.Column>
      </Grid>
    </Fragment>
  );
}
